import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JobsActions } from '../../../../modules/support/piper/piper.service';

export interface PiperActionsModalData {
  nbOfPipelines: number;
  action: JobsActions;
}

export enum ModalResponse {
  CLICK_CLOSE = 'close',
  CLICK_ACCEPT = 'accept'
}

@Component({
  selector: 'app-piper-actions-modal',
  templateUrl: './piper-actions-modal.component.html',
  styleUrls: ['./piper-actions-modal.component.scss']
})
export class PiperActionsModalComponent implements OnInit {

  ModalResponse = ModalResponse;

  constructor(
    public dialogRef: MatDialogRef<PiperActionsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PiperActionsModalData
  ) { }

  ngOnInit() {
    console.log(this.data);
  }

  closeDialog(response: ModalResponse) {
    this.dialogRef.close(response);
  }

}
